import { styled, css } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Container = styled(Box)`
  /* display: grid; */
  /* grid-template-areas:
    'board board board board'
    'board board board board'; */
  /* grid-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr; */
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  /* justify-content: flex-start;
  width: 100%;
  @media (max-width: 1815px) {
    grid-template-areas:
      'board board board '
      'board board board';
    justify-content: flex-start;
  }
  @media (max-width: 1360px) {
    grid-template-areas:
      'board board'
      'board board';
    justify-content: flex-start;
  } */
`;

export const SectionRemove = styled(Box)`
  padding: 0px 20px 0 20px;
  height: 53px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 1px solid #dddddd;

  .btn-archive {
    gap: 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.54);
  }
`;

export const SectionMembers = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;
  height: 53px;
  gap: 15px;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface CardProps {
  status: string;
  disabled: boolean;
}

export const Card = styled(Box)`
  /* grid-area: 'board'; */
  padding: 23px 26px;
  width: 360px;
  flex: 1 1 360px;

  height: 148px;
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  cursor: pointer;
  border-left: 12px solid;
  ${(props: CardProps) =>
    props.status === 'BS2' &&
    css`
      background-color: #bdbdbd;
    `};
  ${(props: CardProps) =>
    props.disabled &&
    css`
      background-color: #bdbdbd;
      cursor: not-allowed;
    `};
  /* @media (max-width: 1815px) {
    width: 25.7vw;
  }
  @media (max-width: 1320px) {
    width: 38.7vw;
  } */
`;
export const MembersNumber = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #9e9e9e;
`;
export const AvatarMember = styled(Box)``;
export const BallStatus = styled(Box)`
  width: 13px;
  height: 13px;
  border-radius: 50%;
`;

export const Page = styled(Box)``;
export const Div = styled(Box)`
  height: 80%;
  width: 100%;
`;
